// The Firebase compat SDK is loaded by <script defer> tags before this bundle; `firebase` is a global.
/* global firebase */
const firebaseConfig = {
    apiKey: "AIzaSyA9FKZMlfngKfd7XVPFfkZjEmqwbS9LQrw",
    authDomain: "onis-eat.firebaseapp.com",
    databaseURL: "https://onis-eat-default-rtdb.firebaseio.com",
    projectId: "onis-eat",
    storageBucket: "onis-eat.firebasestorage.app",
    messagingSenderId: "775567534955",
    appId: "1:775567534955:web:e61c141020a41786b47a2e"
};

// Initialize Firebase (if the SDK was blocked or failed to load, the app still opens from the local cache)
if (typeof firebase !== 'undefined') {
    firebase.initializeApp(firebaseConfig);
    window.firebaseDB = firebase.database();
    window.firebaseAuth = firebase.auth();
}

// Anonymous sign-in happens in db.js (ensureAuth), which retries after an offline launch.
